import Marquee from "react-fast-marquee";

const WORDS = ["Elevating Spaces", "Crafting Stone", "MG Tiling Pro", "Precision Cuts"];

export const Ribbon = () => {
  return (
    <section
      data-testid="marquee-ribbon"
      className="bg-ink py-10 md:py-16 overflow-hidden border-y border-line select-none"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-black uppercase text-stroke text-[12vw] md:text-[9vw] leading-none px-8 whitespace-nowrap">
              {w}
            </span>
            <span className="text-terracotta text-[8vw] md:text-[5vw] px-4">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
